<template>
    <div>
        <van-overlay :show="show" @click="handleClose" :z-index="3000">
            <div :class="['dialog', { active: !info.products?.length }]" @click.stop>
                <div class="close" @click="handleClose"></div>
                <div class="benefit-reward benefit-area">
                    <div class="reward--title">
                        <div class="title">Get Free Reliefs</div>
                        <div class="product-cutdown"><van-count-down :time="time" /></div>
                    </div>
                    <div class="reward--area">
                        <div class="reward--left">
                            <div>
                                {{ store.cureencySymbol() }}<span>{{ info?.config?.gold }}</span
                                >Relief
                            </div>
                            <div class="left--times">
                                {{ $t('Fund_claim_time') }} <span> {{ info.left }}</span>
                            </div>
                        </div>
                        <div class="reward--right">
                            <div v-if="[1, 3].includes(info.status)" class="benet-btn" @click="receiveCash">{{ $t('FREE') }}</div>
                            <div v-else class="benet-btn cant-recieve">{{ $t('FREE') }}</div>
                            <p v-if="info.status === 2" class="tip">{{ $t('Fund_no_claim_times') }}</p>
                            <!-- <p v-if="info.status === 3" class="tip">{{ $t('Fund_no_phone') }}</p> -->
                            <p v-if="info.status === 5" class="tip">{{ $t('Fund_once_per_phone') }}</p>
                            <p v-if="info.status === 6" class="tip">{{ $t('Fund_claim_Req') }}</p>
                            <p v-if="info.status === 7" class="tip">{{ $t('Fund_claim_aft_game') }}</p>
                            <p v-if="info.status === 8" class="tip">{{ $t('Fund_still_ingame') }}</p>
                        </div>
                    </div>
                </div>
                <template v-if="info.products?.length">
                    <div class="benefit-product benefit-area" v-for="(item, index) in info.products" :key="index">
                        <div class="product--title">Limited-Time Deposit Offer</div>
                        <div class="product">
                            <img class="product-icon" src="@/assets/img/cash_dialog/coin.png" />
                            <div class="product-des">
                                <div class="product-num">{{ store.cureencySymbol() }}{{ item.config.cny }}</div>
                                <div class="product-relief">
                                    <span>+{{ item.times }}</span> Times Relief
                                </div>
                            </div>
                            <div class="product-btn" @click="handleDeposit(item)">{{ $t('Recharge') }}</div>
                        </div>
                    </div>
                </template>
            </div>
        </van-overlay>
        <ProductChannel v-model="showChannel" @recharged="recharged" />
    </div>
</template>
<script setup lang="ts">
import ProductChannel from './productChannel.vue'
import dayjs from 'dayjs'
import { useBaseStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { Log } from '@/api/log'
import popupManager from '@/utils/PopupManager'
import eventBus from '@/utils/bus'

const props = defineProps({
    type: {
        type: Number,
        default: () => 0,
    },
})

const store = useBaseStore()
const i18n = useI18n()

const show = ref(false)
const showChannel = ref(false)

const info = ref({})
const time = ref(getLiftTime())

const orderParams = reactive({
    item: {},
    source: 'reliefaward',
})
provide('orderParams', orderParams)

const handleClose = () => {
    show.value = false
    popupManager.checkQueue()
}
function getLiftTime() {
    // 获取当前时间的毫秒数
    const now = dayjs()
    // 获取当天24点的时间戳
    const endOfDay = dayjs().endOf('day').valueOf()
    // 计算当前时间到当天24点的剩余毫秒数
    return endOfDay - now.valueOf()
}

const handleDeposit = (item) => {
    Log({
        event: 'reliefaward',
        content: {
            number: item.config.cny,
        },
    })
    orderParams.item = item.config
    showChannel.value = true
}
const recharged = () => {
    show.value = false
}
async function checkRelief() {
    try {
        const res = await store.getSignEvent({ id: 'reliefaward' }, false, false)
        const status = res?.acticity?.status
        if (res?.code === 200) {
            info.value = res.acticity

            if ([1, 2, 3].includes(status)) {
                show.value = true
            } else if (status === 0) {
                show.value && showToast(i18n.t('Fund_no_event'))
                popupManager.checkQueue()
            } else if (props.type === 1) {
                show.value = true
            } else {
                popupManager.checkQueue()
            }
        } else {
            popupManager.checkQueue()
        }
    } catch (e) {
        popupManager.checkQueue()
    }
}
const receiveCash = async () => {
    if (info.value.status === 3) {
        showToast(i18n.t('Fund_no_phone'))
        setTimeout(() => {
            show.value = false
            // emits('showBindDialog')
            eventBus.emit('activity', {
                param: '/bindPhone',
            })
        }, 1000)
        return
    }
    try {
        const res = await store.ReceiveRewards({ id: 'reliefaward' })
        if (res.code === 200) {
            show.value = false
            showToast(i18n.t('Successful_collection'))
        }
    } catch (e) {
        console.log(e)
    }
}
onMounted(() => {
    checkRelief()
})
</script>
<style lang="scss" scoped>
.dialog {
    @apply flex flex-col;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 750px;
    min-height: 800px;
    height: 951px;
    padding: 360px 30px 0 50px;
    background: url('@/assets/img/cash_dialog/benet_bg.png') no-repeat;
    background-size: 100% 100%;
    transform: translate3d(-50%, -50%, 0);
    overflow: hidden;
    &.active {
        height: auto;
    }

    .close {
        position: absolute;
        top: 34px;
        right: 30px;
        width: 35px;
        height: 36px;
        background: url('@/assets/img/dialog/welcome_shut.png') no-repeat;
        background-size: 100% 100%;
    }
    .benefit-area {
        background-image: linear-gradient(#403258, #403258), linear-gradient(#000000, #000000);
        background-blend-mode: normal, normal;
        border-radius: 10px;
        overflow: hidden;
    }

    .benefit-reward {
        margin-bottom: 31px;
        width: 649px;
        height: 267px;

        .reward--title {
            @apply flex items-center;
            height: 80px;
            padding: 0 23px 0 29px;
            background: #4b3b68;
            font-size: 30px;

            .title {
                flex: 1;
                color: #ae9fc9;
            }
            .van-count-down {
                padding: 0 18px 0 55px;
                width: 206px;
                height: 44px;
                background: url('@/assets/img/cash_dialog/time.png') no-repeat;
                background-size: 100% 100%;
                color: #8e80a8;
            }
        }
        .reward--area {
            @apply flex;
            padding: 30px 45px 0 29px;

            .reward--left {
                @apply flex-1 flex flex-col  items-center;
                font-size: 24px;
                color: #fcfbff;
                font-size: 57px;
                font-weight: bold;
                line-height: 80px;
                span {
                    margin: 0 5px;
                    color: #fb70ff;
                    font-size: 85px;
                }
                .left--times {
                    line-height: 40px;
                    font-size: 24px;
                    color: #8e80a8;
                    span {
                        font-size: 24px;
                    }
                }
            }
            .reward--right {
                @apply flex flex-col items-end;
                min-width: 230px;
                padding-top: 15px;
                .benet-btn {
                    @apply flex justify-center items-center;
                    width: 203px;
                    height: 64px;
                    background-image: linear-gradient(0deg, #d34bfd 0%, #e659fe 54%, #f966ff 100%), linear-gradient(#000000, #000000);
                    background-blend-mode: normal, normal;
                    box-shadow: inset 0px 2px 0px 0px #f0bcff;
                    border-radius: 29px;
                    font-size: 36px;
                    color: #fff;

                    &.cant-recieve {
                        opacity: 0.6;
                        pointer-events: none;
                    }
                }
                .tip {
                    margin-top: 12px;
                    font-size: 24px;
                    color: #8e80a8;
                }
            }
        }
    }
    .benefit-product {
        width: 649px;
        height: 247px;
        padding: 0 24px;

        .product--title {
            line-height: 80px;
            font-size: 30px;
            color: #ae9fc9;
        }
        .product {
            @apply flex items-center gap-[30px];
            padding: 0 20px 0 27px;
            height: 141px;
            background-image: linear-gradient(#564478, #564478), linear-gradient(#333333, #333333);
            background-blend-mode: normal, normal;
            border-radius: 16px;
            border: solid 3px #644f8d;

            .product-icon {
                width: 121px;
                height: 86px;
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
            }

            .product-des {
                @apply flex flex-col justify-center;
                flex: 1;

                .product-num {
                    line-height: 40px;
                    color: #fff;
                    font-size: 38px;
                }

                .product-relief {
                    font-size: 24px;
                    color: #8e80a8;

                    span {
                        color: #fff830;
                    }
                }
            }

            .product-btn {
                @apply flex justify-center items-center;
                width: 173px;
                height: 63px;
                background-image: linear-gradient(0deg, #ffa72a 0%, #ffc44f 100%), linear-gradient(#e59e20, #e59e20);
                background-blend-mode: normal, normal;
                box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.44);
                border-radius: 29px;
                font-size: 28px;
                font-weight: bold;
                color: #fff;
            }
        }
    }
}
</style>
